import { render, staticRenderFns } from "./my.vue?vue&type=template&id=0bcb0243&scoped=true"
import script from "./my.vue?vue&type=script&lang=js"
export * from "./my.vue?vue&type=script&lang=js"
import style0 from "./my.vue?vue&type=style&index=0&id=0bcb0243&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcb0243",
  null
  
)

export default component.exports